/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="16.61" height="61.71" viewBox="0 0 16.61 61.71" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <polyline points="0.72 0.36 15.72 30.4 0.72 61.36" stroke="#8a8a8a" className="icon-stroke" strokeWidth="1.6"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronRightNarrowIcon';

export default Icon;
